













import Component, { mixins } from 'vue-class-component';
import { LocalStorage } from './utils/LocalStorageMixin';
import Roulette from './components/Roulette.vue';

@Component({
  components: {
    Roulette,
  },
})
export default class App extends mixins(LocalStorage) {
  storeKeys = ['slicesInput', 'labelsInput'];
  slicesInput = '0.25 0.25 0.25 0.25';
  labelsInput = '';

  get slices() {
    return this.slicesInput.trim().split(' ').map(parseFloat);
  }
  get labels() {
    if (this.labelsInput === '') return [];
    return this.labelsInput.trim().split(' ');
  }
}
